import { useEffect, useRef, useState } from 'react';
import { Button, Dialog, Grid, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface RemarkDialogBoxProps {
  open: boolean;
  handleClose: () => void;
  onSubmit: (data) => void;
  title: string;
  submitBtnName: string;
  getRemark?: string;
}

const RemarkDialogBox: React.FC<RemarkDialogBoxProps> = ({
  open,
  handleClose,
  onSubmit,
  title,
  submitBtnName,
  getRemark
}) => {
  const TextFieldStyle = {
    fontSize: '12px',
    width: '100%'
  };

  const textFieldRef = useRef(null);
  const [remark, serRemark] = useState('');

  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (open) {
      serRemark(getRemark);
    }
  }, [open, getRemark]);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={handleClose}
      className="remark-dialog-box"
    >
      <Grid
        item
        xs={12}
        sx={{ p: 3, pb: 2 }}
        display="flex"
        justifyContent="space-between"
      >
        <Typography
          style={{ fontSize: '14px', fontWeight: '700' }}
          variant="h4"
        >
          {title}
        </Typography>
        <CloseIcon
          onClick={handleClose}
          style={{
            fontSize: '17px',
            cursor: 'pointer'
          }}
        />
      </Grid>
      <Grid item xs={12} sx={{ p: 3, pt: 0 }} gap={1}>
        <Grid item xs={12} pb="1rem">
          <TextField
            inputRef={textFieldRef}
            sx={{ mt: '4px' }}
            className="input-text"
            size="small"
            variant="outlined"
            multiline
            rows={4}
            style={TextFieldStyle}
            placeholder={`Enter ${title}`}
            inputProps={{
              max: 100,
              min: 0,
              style: {
                fontSize: '12px',
                padding: '6.5px 14px'
              }
            }}
            type="text"
            value={remark}
            onChange={(e) => {
              serRemark(e.target.value);
            }}
          />
        </Grid>
        <Grid
          item
          sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
          xs={12}
        >
          <Button
            id="btn-onClose"
            sx={{
              width: '80px',
              fontWeight: 'normal',
              background: '#F5F7FF',
              fontSize: '13px'
            }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            id="btn-onSubmit"
            sx={{
              ml: 2,
              width: '80px',
              fontSize: '13px',
              fontWeight: 'normal',
              background: '#0069E4',
              textTransform: 'capitalize'
            }}
            variant="contained"
            type="submit"
            onClick={() => onSubmit(remark)}
          >
            {submitBtnName}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default RemarkDialogBox;
